import type { App } from "vue";
import router from "../router";
import i18n from "@/i18n";

export function registerPlugins(app: App) {
	app.use(i18n);
	app.use(router);
}
